import { render, staticRenderFns } from "./EmptyBlock.vue?vue&type=template&id=39d7af0c&"
import script from "./EmptyBlock.vue?vue&type=script&lang=js&"
export * from "./EmptyBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports